export interface UpdateReserveGroupRequest {
  id: number
  name: string
  nameKana: string
  bibliographies: {
    reserveGroupDetailId: number
    bibliographyRealId: number
  }[]
  revision: number
}

export function UpdateReserveGroupRequestToJSON(
  value: UpdateReserveGroupRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              reserve_group_detail_id:
                bibliography.reserveGroupDetailId !== 0
                  ? bibliography.reserveGroupDetailId
                  : undefined,
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined
            }
          })
        : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
